import { DefaultStages } from '@shared/types/frontend';
import { useEffect } from 'react';
import { NormieRowType } from '@shared/types/frontend/tables';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { useSearchHomeContext } from '@/contexts/SearchHomeProvider';
import { useSavedToken } from '@/hooks/saved/useSavedToken';
import { useRecentToken } from '@/hooks/saved/useRecentToken';
import Loading from '@/components/shared/Loading';
import NormieTable from '../../../explore/desktop/normie-mode/NormieTable';
import { Button } from '@/components/ui/button';
import useAuthGuard from '@/hooks/auth/useAuthGuard';
import classNames from '@/lib/misc/classNames';
import { Switch } from '@/components/ui/switch';
interface SearchResultProps {
  input: string;
}
const SearchResults: React.FC<SearchResultProps> = ({
  input
}) => {
  const {
    handleSearch,
    keyword,
    setKeyword,
    timeFrame,
    resultsToUse,
    useUnprotectedSearch,
    setUseUnprotectedSearch,
    mode,
    setMode,
    stage,
    wildWest,
    showWildWest
  } = useSearchHomeContext();
  const {
    shouldOnboard
  } = useAuthGuard();
  const {
    handleClearSavedTokens
  } = useSavedToken({});
  const {
    handleClearRecentTokens
  } = useRecentToken();
  useEffect(() => {
    if (input !== '' && keyword !== input) {
      setKeyword(input);
      setMode('search');
      handleSearch(input);
      return;
    }
    if (input === '') {
      setKeyword('');
      setMode('recent');
      return;
    }
    return () => {};
  }, [input, keyword]);
  const NoResultsView = () => {
    return <div className='ta-c justify-center w-full m-auto' data-sentry-component="NoResultsView" data-sentry-source-file="SearchResults.tsx">
        <ImageWithFallback src='/static/icons/nothingcircle.png' alt='nothing' width={80} height={80} className='m-auto' data-sentry-element="ImageWithFallback" data-sentry-source-file="SearchResults.tsx" />
        <p className='text-[12px] text-genius-cream/50 mt-6'>
          {mode === 'search' ? 'No Safe Search Results' : mode === 'new' ? 'No New Tokens in the last 24 hours' : (mode === 'saved' || mode === 'recent') && shouldOnboard ? 'Sign In to see results' : 'No Results'}
        </p>
      </div>;
  };
  const tokensToUse = resultsToUse();
  return <div className='flex flex-col absolute top-10 w-[820px] h-[400px] overflow-hidden bg-genius-indigo pt-4 rounded-lg z-[1000] border border-genius-blue genius-shadow' data-sentry-component="SearchResults" data-sentry-source-file="SearchResults.tsx">
      <div className={classNames('flex items-center justify-between px-4 pb-3 gap-2 w-full border-b border-genius-blue')}>
        <div className=''>Safe Search</div>
        <Switch checked={!wildWest} onClick={() => {
        showWildWest(!wildWest);
      }} data-sentry-element="Switch" data-sentry-source-file="SearchResults.tsx" />
      </div>
      <div className='flex items-center justify-between mb-2'>
        <div className='flex items-center justify-start pt-2'>
          <p onClick={() => setMode('recent')} className={`cursor-pointer ml-4 text-[16px] ${mode === 'recent' ? 'text-genius-cream' : 'text-genius-cream/50'}  `}>
            Recent
          </p>
          <p onClick={() => setMode('saved')} className={`cursor-pointer ml-4 text-[16px] ${mode === 'saved' ? 'text-genius-cream' : 'text-genius-cream/50'}  `}>
            Saved
          </p>
        </div>
        <div className='pt-4 pr-5'>
          <Button onClick={() => mode === 'recent' ? handleClearRecentTokens() : handleClearSavedTokens()} className={`bg-genius-blue text-[14px] w-[90px] h-[28px] mr-2 rounded-full text-genius-cream ${mode !== 'recent' && mode !== 'saved' ? 'opacity-0' : ''} transition-opacity`} data-sentry-element="Button" data-sentry-source-file="SearchResults.tsx">
            Clear All
          </Button>
        </div>
      </div>
      {stage === DefaultStages.loading ? <div className='h-full w-full flex items-center flex-col justify-center -translate-y-8'>
          <Loading className='h-8 w-8' />
        </div> : stage === DefaultStages.results ? <>
          {tokensToUse && tokensToUse.length > 0 && tokensToUse[0] !== null ? <NormieTable key={`${mode}`} isSearchResults={mode === 'search'} resultsToUse={[...(mode === 'search' ? [{
        type: NormieRowType.HEADER,
        content: 'Search Results',
        className: 'text-[16px] text-genius-cream ml-4',
        height: 34
      }] : []), ...(tokensToUse ?? [])]} setKeyword={setKeyword} timeFrame={timeFrame} /> : <div className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center mt-14 flex-col'>
              <NoResultsView />
              {mode === 'search' && !useUnprotectedSearch && <div className='cursor-pointer bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => {
          setUseUnprotectedSearch(true);
        }}>
                  Show Low Volume Results {shouldOnboard}
                </div>}
            </div>}
        </> : stage === DefaultStages.noResults ? <div className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center mt-14 flex-col'>
          <NoResultsView />
          {mode === 'search' && !useUnprotectedSearch && <div className='cursor-pointer bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => {
        setUseUnprotectedSearch(true);
      }}>
              Show Low Volume Results {shouldOnboard}
            </div>}
        </div> : null}
    </div>;
};
export default SearchResults;